module.exports = __webpack_public_path__ + "static/media/diamond.b694607a.png";